import messagesEn from './en/en.json'
import messagesAr from './ar/ar.json'
import messagesEs from './es/es.json'
import messagesDe from './de/de.json'
import messagesIt from './it/it.json'
import messagesFr from './fr/fr.json'
import messagesPt from './pt/pt.json'
import messagesEl from './el/el.json'
import messagesBn from './bn/bn.json'
import messagesSr from './sr/sr.json'
import messagesCs from './cs/cs.json'
import messagesPl from './pl/pl.json'
import messagesHu from './hu/hu.json'
import messagesSk from './sk/sk.json'
import messagesRo from './ro/ro.json'
import messagesBg from './bg/bg.json'
import messagesMk from './mk/mk.json'
import messagesSq from './sq/sq.json'

const MessagesMessages = {
  en: { messages: { ...messagesEn } },
  ar: { messages: { ...messagesAr } },
  es: { messages: { ...messagesEs } },
  de: { messages: { ...messagesDe } },
  it: { messages: { ...messagesIt } },
  fr: { messages: { ...messagesFr } },
  pt: { messages: { ...messagesPt } },
  el: { messages: { ...messagesEl } },
  bn: { messages: { ...messagesBn } },
  sr: { messages: { ...messagesSr } },
  cs: { messages: { ...messagesCs } },
  pl: { messages: { ...messagesPl } },
  hu: { messages: { ...messagesHu } },
  sk: { messages: { ...messagesSk } },
  ro: { messages: { ...messagesRo } },
  bg: { messages: { ...messagesBg } },
  mk: { messages: { ...messagesMk } },
  sq: { messages: { ...messagesSq } },
}

export default MessagesMessages
